// extracted by mini-css-extract-plugin
export default {"root":"RecordSender_root__GhMVJ","formControl":"RecordSender_formControl__vJOGN","successMessage":"RecordSender_successMessage__xhLnY"};